import normalize from 'normalize-jss';

import {merge} from '-/util/lodash';
import {fontFace, rem, size, smallScreen, standardFont} from '-/styles/utils';

export default theme => {
    const geosuggest = {
        '@global': {
            '.address-suggestions': {
                display: 'block',
                position: 'absolute',
                background: 'white',
                zIndex: 100000,
                border: 'solid 1px #bbb',
                width: '100%',
                borderTop: 'none',
                filter: 'drop-shadow(0px 2px 5px rgba(0, 0, 0, .4))'
            },
            '.address-suggestion': {
                padding: '8px 5px',
                cursor: 'pointer',
                fontSize: 11,
                color: '#333',
                borderBottom: 'dashed 1px #ccc',
                '&.selected, &:hover': {
                    backgroundColor: '#eee'
                },
                '&:last-child': {
                    borderBottom: 'none'
                }  
            }
        }
    };
    const styles = {
        '@global': {
            '@-ms-viewport': {
                width: 'device-width'
            },
            html: {
                fontSize: '100%',
                boxSizing: 'border-box'
            },
            '*, html': {
                margin: 0,
                padding: 0
            },
            '*, *:after, *:before': {
                boxSizing: 'inherit'
            },
            'input[type=\'tel\'], textarea, input[type=\'email\'], input[type=\'number\'], input[type=\'text\']': {
                WebkitAppearance: 'none',
                borderRadius: 0
            },
            'button, html [type="button"], [type="reset"], [type="submit"]': {
                //'-webkit-appearance': 'button'
            },
            body: {
                ...size('100%'),
                minWidth: 320,
                backgroundColor: 'gray',
                '@media all and (max-width: 768px)': {
                    backgroundColor: theme.colors.background
                },
                fontFamily: theme.fontFamily,
                color: theme.colors.greeting
            },
            'html, body, #app': {
                height: '100%'
            },
            'h1': {
                marginBottom: rem(15),
                fontSize: rem(36),
                fontWeight: 'normal',
                textAlign: 'center',
                lineHeight: rem(49),
                ...smallScreen({
                    lineHeight: rem(32)
                })
            },
            'h2': {
                marginBottom: rem(10),
                fontSize: rem(24),
                fontWeight: 'normal',
                textAlign: 'center',
                lineHeight: rem(33),
                ...smallScreen({
                    lineHeight: rem(16)
                })
            },
            'ul.info, p.info, div.info': {
                ...standardFont(),
                marginBottom: rem(17),
                '&.subtle': {
                    fontSize: rem(14)
                },
                '&.vin': {
                    marginTop: rem(17),
                    marginBottom: rem(0)
                },
                '&.accessories': {
                    marginTop: rem(17),
                    marginBottom: rem(0)
                }
            },
            'ul.smallInfo, p.smallInfo, div.smallInfo': {
                ...standardFont(),
                fontSize: rem(15),
                opacity: 0.8
            },
            '.center': {
                textAlign: 'center'
            },
            img: {
                verticalAlign: 'inherit'
            },
            fieldset: {
                margin: 0
            },
            '@keyframes bounce': {
                '0%': {
                    transform: 'scale(1)'
                },
                '50%': {
                    transform: 'scale(2)'
                },
                '100%': {
                    transform: 'scale(1)'
                }
            },
            '@keyframes spin': {
                'from': {
                    transform: 'rotate(0deg)'
                },
                'to': {
                    transform: 'rotate(360deg)'
                }
            },
            '@keyframes active': {
                '0%': {
                    transform: 'scale(.1)',
                    opacity: 1
                },
                '70%': {
                    transform: 'scale(2.5)',
                    opacity: 0
                },
                '100%': {
                    opacity: 0
                }
            },
            '.poweredBy': {
                display: 'block',
                textAlign: 'center',
                fontSize: rem(10),
                color: '#7A7A7B',
                textDecoration: 'none',
                verticalAlign: 'middle'
            },
            '.mccLogoGray': {
                height: 16,
                marginLeft: 10
            },
            '.input-symbol-wrapper': {
                position: 'relative'
            },
            '.input-symbol': {
                left: -25,
                top: 0,
                position: 'absolute',
                height: '100%',
                zIndex: 1,
                backgroundColor: '#efefef',
                borderLeft: '1px solid gainsboro',
                width: 25,
                textAlign: 'center',
                paddingTop: 15,
                fontSize: '14px'
            },
            '.splitStyle': {
                marginTop: 10,

                '& ul': {
                    listStyle: 'none',
                    paddingLeft: 35,
                    marginTop: 10
                },
                '& li': {
                    marginBottom: 10
                }
            },
            ...fontFace()
        }
    };

    return merge(normalize, styles, geosuggest);
};
